import { Box, Button, Typography } from '@mui/material';
import { Dialog } from 'components/Dialogs';
import { AcceptAICapTableModalProps } from './AcceptAICapTableModal.props';
import {
  acceptAllButtonSx,
  actionsContainerSx,
  confirmationBodySx,
} from './AcceptAICapTableModal.styles';

const AcceptAICapTableModal = ({
  open,
  onClose,
  onConfirm,
  isSubmitting = false,
}: AcceptAICapTableModalProps) => (
  <Dialog
    open={open}
    onClose={onClose}
    title="Accept AI Generated Cap Table"
    maxWidth="sm"
    fullWidth>
    <Box id="accept-ai-captable-modal-content" sx={confirmationBodySx}>
      <Typography>
          This will accept all AI-suggested values across the cap table.
      </Typography>
      <Typography variant="body2" color="text.secondary">
          You can still manually adjust individual cells after accepting. This action cannot be
          undone in bulk.
      </Typography>
    </Box>
    <Box sx={actionsContainerSx}>
      <Button
        variant="outlined"
        color="primary"
        onClick={onClose}
        disabled={isSubmitting}
        data-testid="accept-ai-captable-modal-cancel">
          Cancel
      </Button>
      <Button
        onClick={() => onConfirm()}
        disabled={isSubmitting}
        sx={acceptAllButtonSx}
        data-testid="accept-ai-captable-modal-confirm">
        {isSubmitting ? 'Accepting…' : 'Accept All'}
      </Button>
    </Box>
  </Dialog>
);

export default AcceptAICapTableModal;
